<i18n>
  {
    "fr": {
      "CreateSuccess": "La règle a bien été créée"
    }
  }
</i18n>
<template>
  <div>
    <BaseHeader class="pb-6" type="default">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h1 class="h2 text-white d-inline-block mb-0">
            Ajouter un frais de transport
          </h1>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <RouteBreadcrumb />
          </nav>
        </b-col>
      </b-row>
    </BaseHeader>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <DeliveryRuleForm
            title="Frais de transport"
            :on-success="save"
            redirect="/shipping/delivery_rules/index"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { RouteBreadcrumb, BaseHeader } from '@coop-zone/coop-zone-argon'
import { mapState } from 'vuex'
import DeliveryRuleForm from '@/components/Shipping/DeliveryRules/DeliveryRuleForm'

export default {
  components: {
    DeliveryRuleForm,
    RouteBreadcrumb,
    BaseHeader,
  },
  created() {
    this.$store.commit('shipping/rules/SET_RULE', {})
  },
  methods: {
    async save() {
      await this.$store.dispatch('shipping/rules/createRule')
      this.$notify({
        message: this.$t('CreateSuccess'),
        timeout: 5000,
        icon: 'ni ni-check-bold',
        type: 'success',
      })
    },
  },
}
</script>
